import {
	InlineMessage,
	InlineMessageStatusType,
	LayoutBox,
} from '@bamboohr/fabric';
import { getBannerMessaging } from './domain';

export interface EmployeeTaxTypeBannerProps {
	/**
	 * The selected Employee Tax Type from the drop down
	 */
	selectedEmployeeTaxTypeId?: string | number | null;
}

/**
 * Shows a banner message if the selected employee tax type is owner or corporate officer informing the user that they might be exempt from Federal or State taxes
 */
export function EmployeeTaxTypeBanner({
	selectedEmployeeTaxTypeId,
}: EmployeeTaxTypeBannerProps) {
	if (!selectedEmployeeTaxTypeId) {
		return null;
	}

	const messaging = getBannerMessaging(selectedEmployeeTaxTypeId);

	if (!messaging) {
		return null;
	}

	return (
		<LayoutBox paddingTop={2}>
			<InlineMessage
				{...messaging}
				icon="circle-info-solid"
				status={InlineMessageStatusType.neutral}
			/>
		</LayoutBox>
	);
}
